import { render, staticRenderFns } from "./mmpCampEdit.vue?vue&type=template&id=cbb9d9f4"
import script from "./mmpCampEdit.vue?vue&type=script&lang=js"
export * from "./mmpCampEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports